import React, {useState} from 'react'
import styled from 'styled-components';
import NextIcon from './assets/next.svg';
import PrevIcon from './assets/prev.svg';
import { Link } from 'gatsby';
import StoryItem from '../../storyItem';

const maxMobileWidth = 768;
const storyItemWidth = 210
const transformStep = storyItemWidth
const numberOfSlidesOnScreen = typeof window !== "undefined" ?  Math.floor(window.innerWidth/storyItemWidth) : 0


const StorySlider = ({stories, title, subtitle, sliderIndex, showMoreLink, type}) => {
  const [transformValue, setTransformValue] = useState(0)
  const slidesNotOnscreen = stories.length - numberOfSlidesOnScreen
  const maxTransformValue = slidesNotOnscreen > 0 ? slidesNotOnscreen*storyItemWidth : 0
  const showPrevButton = transformValue > 0
  const showNextButton = transformValue < maxTransformValue
  const handleNext = () => {  
    setTransformValue(prev => prev + transformStep)
  }

  const handleBack = () => {  
    if(transformValue === 0) return
    setTransformValue(prev => prev - transformStep)
  }

  return (
    <Wrapper>
      <SliderTitleWrapper>
        <SliderTitle dangerouslySetInnerHTML={{ __html: title}}/>
        <ShowMore to={showMoreLink}>Show All</ShowMore>
      </SliderTitleWrapper>
      <SliderSubTitle dangerouslySetInnerHTML={{ __html: subtitle}}/>
      <Slider style={{transform: `translateX(-${transformValue}px)`}}>
        {stories.map((story, index) => (
          <StoryItem 
            key={story.id} 
            story={story}
            lazyLoadImg={index > 5 || sliderIndex > 1}
            margin
          />
        ))}
      </Slider>
      {showNextButton &&
        <NextButton onClick={handleNext}>
          <img src={NextIcon} alt="next" />
        </NextButton>
      }
      {showPrevButton &&
        <BackButton onClick={handleBack}>
          <img src={PrevIcon} alt="prev" />
        </BackButton>
      }
    </Wrapper>
  )
}

export default StorySlider

const SliderTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const ShowMore = styled(Link)`
  background-color: #F19D9A;
  padding: 6px 10px;
  color: white;
  border-radius: 16px;
  white-space: nowrap;  
  font-size:12px;
  margin-left:8px;
  font-family: 'Poppins';
  text-decoration:none;
  text-transform:uppercase;
`;


const Wrapper = styled.div`
  position: relative;
  padding: 0px 10px;
`;


const NavButton = styled.button`
  @media (max-width: ${maxMobileWidth}px) {
    display: none;
  }
  background-color: blue;
  width: 34px;
  height: 48px;
  z-index: 100;
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  border: none;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
  background-color: white;
  > img {
    height:16px;
  }
`;

const NextButton = styled(NavButton)`
  border-radius: 5px 0px 0px 5px;
  right: 0;
`;


const BackButton = styled(NavButton)`
  left: 0;
  border-radius: 0px 5px 5px 0px;
`;

const Slider = styled.div`
  overflow:visible;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100vw;
  margin-bottom: 20px;
  transition: transform 0.5s ease;
  @media (max-width: ${maxMobileWidth}px) {
    left: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    overflow-x: scroll;
    position: relative;
    right: 50%;
    -ms-scroll-snap-type: x mandatory;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
  }
`;

const SliderSubTitle = styled.h3`
  font-size:12px;
  font-family: 'Poppins';
  margin: 0px;
  margin-bottom: 20px;
  
`

const SliderTitle = styled.h2`
  font-size:24px;
  margin: 0px 0px;
`